import { useEffect } from "react";
import { Outlet } from "react-router-dom";

/**
 * Private shell for the couples' portal: no marketing layout, no analytics.
 * Already-loaded trackers are neutralised and the page is marked noindex.
 */
export default function WeddingShell() {
  // Synchronous during render, before any effect or paint.
  if (typeof window !== "undefined") {
    window["ga-disable-G-7R2MFQ81WN"] = true;
  }

  useEffect(() => {
    const prev = document.head.querySelector('meta[name="robots"]');
    const prevContent = prev ? prev.getAttribute("content") : null;
    let el = prev;
    if (!el) {
      el = document.createElement("meta");
      el.setAttribute("name", "robots");
      document.head.appendChild(el);
    }
    el.setAttribute("content", "noindex, nofollow, noarchive");

    const noop = () => {};
    const saved = { gtag: window.gtag, fbq: window.fbq };
    window.gtag = noop;
    window.fbq = noop;
    try { window.posthog?.opt_out_capturing?.(); } catch { /* noop */ }
    const pixel = document.querySelector('noscript img[src*="facebook.com/tr"]');
    pixel?.closest("noscript")?.remove();

    return () => {
      window.gtag = saved.gtag;
      window.fbq = saved.fbq;
      window["ga-disable-G-7R2MFQ81WN"] =
        window.location.pathname.startsWith("/espace-reception") ||
        window.location.pathname.startsWith("/espace-mariage");
      if (prevContent != null) el.setAttribute("content", prevContent);
      else el.remove();
    };
  }, []);

  return (
    <div data-testid="wedding-shell" className="min-h-screen bg-[#F6F0E7] text-[#203240]">
      <Outlet />
    </div>
  );
}
